/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as StationRouteImport } from './../routes/_station'
import { Route as DesignRouteImport } from './../routes/design'
import { Route as StationIndexRouteImport } from './../routes/_station/index'
import { Route as StationExpiryRouteImport } from './../routes/_station/expiry'
import { Route as StationLabelsRouteImport } from './../routes/_station/labels'
import { Route as StationOrdersRouteImport } from './../routes/_station/orders'
import { Route as StationProductionRouteImport } from './../routes/_station/production'
import { Route as StationReceivingRouteImport } from './../routes/_station/receiving'
import { Route as StationScanRouteImport } from './../routes/_station/scan'
import { Route as StationStockTakeRouteImport } from './../routes/_station/stock-take'

const StationRoute = StationRouteImport.update({
  id: '/_station',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const StationIndexRoute = StationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StationRoute,
} as any)
const StationExpiryRoute = StationExpiryRouteImport.update({
  id: '/expiry',
  path: '/expiry',
  getParentRoute: () => StationRoute,
} as any)
const StationLabelsRoute = StationLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => StationRoute,
} as any)
const StationOrdersRoute = StationOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StationRoute,
} as any)
const StationProductionRoute = StationProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => StationRoute,
} as any)
const StationReceivingRoute = StationReceivingRouteImport.update({
  id: '/receiving',
  path: '/receiving',
  getParentRoute: () => StationRoute,
} as any)
const StationScanRoute = StationScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => StationRoute,
} as any)
const StationStockTakeRoute = StationStockTakeRouteImport.update({
  id: '/stock-take',
  path: '/stock-take',
  getParentRoute: () => StationRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof StationIndexRoute
  '/design': typeof DesignRoute
  '/expiry': typeof StationExpiryRoute
  '/labels': typeof StationLabelsRoute
  '/orders': typeof StationOrdersRoute
  '/production': typeof StationProductionRoute
  '/receiving': typeof StationReceivingRoute
  '/scan': typeof StationScanRoute
  '/stock-take': typeof StationStockTakeRoute
}
export interface FileRoutesByTo {
  '/design': typeof DesignRoute
  '/expiry': typeof StationExpiryRoute
  '/labels': typeof StationLabelsRoute
  '/orders': typeof StationOrdersRoute
  '/production': typeof StationProductionRoute
  '/receiving': typeof StationReceivingRoute
  '/scan': typeof StationScanRoute
  '/stock-take': typeof StationStockTakeRoute
  '/': typeof StationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_station': typeof StationRouteWithChildren
  '/design': typeof DesignRoute
  '/_station/expiry': typeof StationExpiryRoute
  '/_station/labels': typeof StationLabelsRoute
  '/_station/orders': typeof StationOrdersRoute
  '/_station/production': typeof StationProductionRoute
  '/_station/receiving': typeof StationReceivingRoute
  '/_station/scan': typeof StationScanRoute
  '/_station/stock-take': typeof StationStockTakeRoute
  '/_station/': typeof StationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/design'
    | '/expiry'
    | '/labels'
    | '/orders'
    | '/production'
    | '/receiving'
    | '/scan'
    | '/stock-take'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/design'
    | '/expiry'
    | '/labels'
    | '/orders'
    | '/production'
    | '/receiving'
    | '/scan'
    | '/stock-take'
    | '/'
  id:
    | '__root__'
    | '/_station'
    | '/design'
    | '/_station/expiry'
    | '/_station/labels'
    | '/_station/orders'
    | '/_station/production'
    | '/_station/receiving'
    | '/_station/scan'
    | '/_station/stock-take'
    | '/_station/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  StationRoute: typeof StationRouteWithChildren
  DesignRoute: typeof DesignRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_station': {
      id: '/_station'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_station/': {
      id: '/_station/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof StationIndexRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/expiry': {
      id: '/_station/expiry'
      path: '/expiry'
      fullPath: '/expiry'
      preLoaderRoute: typeof StationExpiryRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/labels': {
      id: '/_station/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof StationLabelsRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/orders': {
      id: '/_station/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof StationOrdersRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/production': {
      id: '/_station/production'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof StationProductionRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/receiving': {
      id: '/_station/receiving'
      path: '/receiving'
      fullPath: '/receiving'
      preLoaderRoute: typeof StationReceivingRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/scan': {
      id: '/_station/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof StationScanRouteImport
      parentRoute: typeof StationRoute
    }
    '/_station/stock-take': {
      id: '/_station/stock-take'
      path: '/stock-take'
      fullPath: '/stock-take'
      preLoaderRoute: typeof StationStockTakeRouteImport
      parentRoute: typeof StationRoute
    }
  }
}

interface StationRouteChildren {
  StationExpiryRoute: typeof StationExpiryRoute
  StationLabelsRoute: typeof StationLabelsRoute
  StationOrdersRoute: typeof StationOrdersRoute
  StationProductionRoute: typeof StationProductionRoute
  StationReceivingRoute: typeof StationReceivingRoute
  StationScanRoute: typeof StationScanRoute
  StationStockTakeRoute: typeof StationStockTakeRoute
  StationIndexRoute: typeof StationIndexRoute
}

const StationRouteChildren: StationRouteChildren = {
  StationExpiryRoute: StationExpiryRoute,
  StationLabelsRoute: StationLabelsRoute,
  StationOrdersRoute: StationOrdersRoute,
  StationProductionRoute: StationProductionRoute,
  StationReceivingRoute: StationReceivingRoute,
  StationScanRoute: StationScanRoute,
  StationStockTakeRoute: StationStockTakeRoute,
  StationIndexRoute: StationIndexRoute,
}

const StationRouteWithChildren =
  StationRoute._addFileChildren(StationRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  StationRoute: StationRouteWithChildren,
  DesignRoute: DesignRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
